<!--
 * @FileDescription: 订单退款页面-Web
 * @Author: 陈文景
 * @Date: 2022-11-07 09:42:30
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="container">
    <div style="margin-top: 8px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fontfine" :to="{ path: '/order/list' }">{{ $t('Order.Refund.Web.Index.MyOrder') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('Order.Refund.Web.Index.RefundApplication') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <h3 class="rufund">{{ $t('Order.Refund.Web.Index.RufundOrder') }}</h3>

    <div v-if="other.refunded === 1" class="record">
      <span class="text">{{ $t('Order.Refund.Web.Index.OrderHasBeenRefundedBefore') }}</span>
      <el-button :disabled="!unshippeds.length" class="record-button" round @click="showRefundRecord">{{ $t('Order.Refund.Web.Index.RefundRecord') }}</el-button>
    </div>

    <div v-loading="detailsLoading" class="details">
      <div class="left">
        <div class="reason">
          <el-form :model="form" :rules="rules" ref="form" :label-width="`${labelWidth}px`">
            <el-form-item :label="$t('Order.Refund.Web.Index.RefundReason')" prop="refundReason">
              <el-select v-model="form.refundReason" :disabled="!unshippeds.length" size="medium" :placeholder="$t('Order.Refund.Web.Index.InputContent')">
                <el-option v-for="item in cancelReasonOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('orderList.Remark')">
              <el-input class="border radius" v-model="form.remark" :disabled="!unshippeds.length" type="textarea" maxlength="120" show-word-limit :rows="3" resize="none" :placeholder="$t('Order.Refund.Web.Index.PleaseEnterRemarks')" />
            </el-form-item>
            <el-form-item>
              <div class="imageListBox f fw-w">
                <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    list-type="picture-card"
                    :multiple="true"
                    :before-upload="file => imgUploadBefore(form.imageList, file, form)"
                    v-if="mode !== 'read'">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <template v-if="imageLoading">
                    <div style="width:70px;height:72px" v-loading="true" v-for="(file, index) in uploadImageList" :key="index"></div>
                </template>
                <template v-else>
                  <div class="pictureCard" v-for="(imgUrl, index) in form.imageList" :key="imgUrl">
                      <img :src="imgUrl" @click="imgVisit(imgUrl)">
                      <i class="el-icon-close" @click="imgUrlDelete(form.imageList, index)" v-if="mode !== 'read'"></i>
                      <div class="deleteIcon" @click="imgUrlDelete(form.imageList, index)" v-if="mode !== 'read'"></div>
                  </div>
                </template>
              </div>
            </el-form-item>
          </el-form>
        </div>

        <div class="content">
          <!-- 未发货 -->
          <template v-if="unshippeds.length">
            <NotShippedGoods :data="unshippeds" :refundData="refundData" @change="handleSelectAll" @amount="getCheckedAmountItem" />
          </template>

          <!-- 空状态 -->
          <template v-else>
            <div class="not-data">
              <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
              <span class="tips-text">{{ noRecord }}</span>
            </div>
          </template>
        </div>
      </div>

      <div class="right">
        <div v-loading="amountLoading">
          <div class="amount-info">
            <h3 class="title">{{ $t('Order.Refund.Web.Index.RefundedAmount') }}</h3>
            <p>
              <span>{{ $t('Order.Refund.Web.Index.Subtotal') }}</span>
              <span class="money">US ${{ amountTips(other.itemSubtotal) }}</span>
            </p>
            <p>
              <span>{{ $t('Order.Refund.Web.Index.ShippingFee') }}</span>
              <span class="money">US ${{ amountTips(other.shippingSubtotal) }}</span>
            </p>
            <p>
              <span>{{ $t('Order.Refund.Web.Index.PromoCode') }}</span>
              <span class="money">- US ${{ amountTips(other.promotion) }}</span>
            </p>
            <p>
              <span>{{ $t('Order.Refund.Web.Index.Coupon') }}</span>
              <span class="money">- US ${{ amountTips(other.coupon) }}</span>
            </p>
          </div>

          <div class="refund-info">
            <p>
              <span class="total">{{ $t('Order.Refund.Web.Index.Total') }}:</span>
              <span class="money">- US $ {{ amountTips(other.orderMaximumRefund) }}</span>
            </p>

            <div class="button">
              <el-button :disabled="!unshippeds.length" type="primary" @click="submitApplicationForRefund">{{ $t('Order.Refund.Web.Index.Refund') }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 退款记录对话框 -->
    <RefundRecordDialog ref="refundRecordDialog" />

    <!-- 退款失败提示对话框 -->
    <RefundFaliDialog ref="refundFaliDialog" />
  </div>
</template>

<script>
import API from '@/api'
import NotShippedGoods from './components/NotShippedGoods.vue'
import RefundFaliDialog from './components/RefundFaliDialog.vue'
import RefundRecordDialog from './components/RefundRecordDialog.vue'
import ImageCompressor from 'js-image-compressor'

let form = {
  packItems: [
    // {
    //   kkItemId: undefined, // 商品ID
    //   skuCode: undefined, // 公司SKU
    //   productNum: undefined, // 商品数量
    //   packId: undefined // 包裹ID(未发货包裹不需要传)
    // }
  ], // 已发货
  refundReason: undefined, // 退款原因
  remark: undefined, // 备注
  refundAmount: 0, // 退款文本框(金额格式)
  isNotice: 0, // 0.不通知 1.通知 (是否邮箱通知客户)
  selectAllied: undefined, // 针对未发货包裹 - 是否全选(0.未全选 1.全选)
  imageList: []
}

let getAmountQuery = {
  items: [
    // {
    //   kkItemId: undefined,
    //   skuCode: undefined,
    //   productNum: 0
    // }
  ]
}

export default {
  components: {
    NotShippedGoods,
    RefundFaliDialog,
    RefundRecordDialog
  },
  data() {
    return {
      refundData: {}, // 退款数据
      labelWidth: 132, // 表单Label宽度
      mode: 'add',
      imageLoading: false,
      dialogImageUrl: '',
      dialogVisible: false,
      uploadImageTimer: null,
      uploadImageList: [],
      imageSignValue: '', // 图片上传唯一凭证

      detailsLoading: false,
      amountLoading: false,

      form: { ...form }, // 创建售后单请求参数

      getAmountQuery: { ...getAmountQuery }, // 获取退款金额请求参数

      rules: {
        refundReason: [{ required: true, message: `${this.$t('Order.Refund.Web.Index.Tips1')}`, trigger: 'change' }]
      },

      // 取消原因下拉选项
      cancelReasonOptions: [
        { label: `${this.$t('Order.Refund.Web.Index.OutOfStock')}`, value: 3 },
        { label: `${this.$t('Order.Refund.Web.Index.ShipmentDelay')}`, value: 4 },
        { label: `${this.$t('Order.Refund.Web.Index.DonTWantAnymore')}`, value: 0 },
        { label: `${this.$t('Order.Refund.Web.Index.IncorrectAddressInformation')}`, value: 2 },
        { label: `${this.$t('Order.Refund.Web.Index.ProductSelectionErrorMultipleSelection')}`, value: 1 },
        { label: `${this.$t('Order.Refund.Web.Index.Other')}`, value: 5 }
      ],

      // Refunded Amount
      other: {
        refunded: 0, // 是否有退款记录(0.没有退款记录 1.有退款记录)
        orderMaximumRefund: 0, // 最大退款金额
        itemSubtotal: 0, // Item Subtotal
        shippingSubtotal: 0, // Shipping Subtotal
        promotion: 0, // Promo code
        coupon: 0 // Coupon
      },

      // 未发货商品
      unshippeds: [],

      noRecord: undefined // 无记录文案
    }
  },
  computed: {
    amountTips() {
      return (value) => value || 0
    }
  },
  created() {
    this.getRefundOrderInformation()
  },
  async mounted() {
    let imageSignValue = await API.customProductGetSignValue({ directory: 'common/images/' })
    this.imageSignValue = imageSignValue.data
  },
  methods: {
    /**
     * API 获取可申请退款商品列表
     */
    async getRefundOrderInformation() {
      try {
        this.detailsLoading = true
        let { data, message } = await API.getRefundOrderInformation(this.$route.query.kakaOrderId)
        if (data) {
          this.refundData = data
          this.noRecord = 'No Record'
          this.other.refunded = data.refunded // 是否有退款记录(0.没有退款记录 1.有退款记录)
          this.unshippeds = this.reformUnshippeds(data.items || []) // 未发货
        } else {
          this.noRecord = message
        }
        this.detailsLoading = false
      } catch (error) {
        this.detailsLoading = false
        throw new Error(error.message)
      }
    },

    /**
     * API 创建售后单
     */
    async createAfterSalesOrder() {
      try {
        let { code, data } = await API.createAfterSalesOrder(this.$route.query.kakaOrderId, this.form)
        if (code === 10000) {
          this.$router.push(`/order/success?returnsId=${data}`)
        } else {
          this.$refs.refundFaliDialog.show()
        }
      } catch (error) {
        this.$refs.refundFaliDialog.show()
      }
    },

    /**
     * API 获取退款金额
     */
    async getRefundOrderAmount() {
      try {
        this.amountLoading = true
        let { data, code, message } = await API.getRefundOrderAmount(this.$route.query.kakaOrderId, this.getAmountQuery)
        if (code !== 10000) this.$message.error(message)
        this.other.itemSubtotal = data.skusAmount
        this.other.shippingSubtotal = data.freightAmount
        this.other.promotion = data.promotionAmount // 优惠码金额
        this.other.coupon = data.couponTicketAmount // 优惠券金额
        this.form.refundAmount = data.totalAmount // 可退款金额总数
        this.other.orderMaximumRefund = data.totalAmount // 可退款金额总数
        this.amountLoading = false
      } catch (error) {
        this.amountLoading = false
      }
    },

    /**
     * 改造未发货列表数据
     *
     * @param {Array} unshippeds 未发货列表
     * @returns {Array} 改造后的数据
     */
    reformUnshippeds(unshippeds) {
      // 排序
      unshippeds.sort((x, y) => {
        return y.countryCode.localeCompare(x.countryCode)
      })
      if (unshippeds.length) {
        return unshippeds.map((item) => ({
          ...item,
          options:
            JSON.parse(item.options) &&
            JSON.parse(item.options)
              .map((option) => JSON.parse(option).value)
              .join('、'),
          check: false, // 是否选中
          quantity: 0 // 退款商品数量
        }))
      } else {
        return unshippeds
      }
    },

    /**
     * 获取需要计算退款金额的商品
     */
    getCheckedAmountItem() {
      this.getAmountQuery.items = []
      // 未发货
      this.unshippeds.forEach((item) => {
        if (item.check) {
          this.getAmountQuery.items.push({
            kkItemId: item.kkItemId, // 商品ID
            skuCode: item.skuCode, // 公司SKU
            productNum: item.quantity, // 商品数量
            countryCode: item.countryCode // 拆包国家
          })
        }
      })
      // 调用获取退款金额的接口
      this.getRefundOrderAmount()
    },

    /**
     * 显示退款记录对话框
     */
    showRefundRecord() {
      this.$refs.refundRecordDialog.show(this.$route.query.kakaOrderId)
    },

    /**
     * 选中所有
     *
     * @param {Boolean} value 是否选中
     * @param {Number} type 1.已发货 2.未发货
     * @param {String} packId 包裹ID（操作已发货的包裹时则存在）
     */
    handleSelectAll(value, type, packId) {
      if (type === 2) {
        this.unshippeds.forEach((item) => {
          item.check = value
          item.quantity = value ? item.productNum : 0
        })
      }
      this.getCheckedAmountItem()
    },

    /**
     * 发起申请退款
     */
    submitApplicationForRefund() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 用户上传图片
          this.form.packItems = []
          // 未发货
          this.unshippeds.forEach((item) => {
            if (item.check) {
              this.form.packItems.push({
                kkItemId: item.kkItemId, // 商品ID
                skuCode: item.skuCode, // 公司SKU
                productNum: item.quantity, // 商品数量
                packId: undefined, // 包裹ID(未发货包裹不需要传)
                countryCode: item.countryCode
              })
            }
          })
          if (this.form.packItems.length) {
            this.getIsSelectAll()
            this.createAfterSalesOrder() // 发起请求
          } else {
            this.$message.warning('Please select the product to be refunded!')
          }
        } else {
          return false
        }
      })
    },

    /**
     * 判断是否已经是全选
     * 为了设置this.form.selectAllied参数(是否全选(0.未全选 1.全选))
     * 计算方式：item.quantity === item.productNum 则全选
     */
    getIsSelectAll() {
      this.form.selectAllied = 1
      this.unshippeds.forEach((item) => {
        if (item.quantity !== item.productNum) {
          this.form.selectAllied = 0
        }
      })
    },
    imgUploadBefore(arr, file, form) {
      if ((file.size / 1024 / 1024) > 5) {
        this.$message.error(this.$t('customDetail.pictureSize'))
        return false
      }
      if (['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) {
        if ((arr.length + this.uploadImageList.length) < 5) {
          this.uploadImageList.push(file)
          if (this.uploadImageTimer) {
            clearTimeout(this.uploadImageTimer)
          }
          this.uploadImageTimer = setTimeout(() => {
            this.imgUploadHandle(arr, form)
          }, 100)
        } else {
          this.$message.error(this.$t('promptText.msg33') + ` 5`)
          this.uploadImageList = []
        }
      } else {
        this.$message.error(this.$t('customDetail.onlyPictures'))
        this.uploadImageList = []
      }
      return false
    },
    imgUploadHandle(arr, form) {
      const that = this
      const imgFormData = new FormData()
      imgFormData.append('directory', 'common/images/')
      imgFormData.append('signValue', that.imageSignValue)
      let alReadyCompressList = []
      this.imageLoading = true
      that.uploadImageList.map(e => alReadyCompressList.push(this.imageCompressorHandle(e)))
      Promise.all(alReadyCompressList).then(() => {
        alReadyCompressList.forEach(e => e.then(res => imgFormData.append('fileList', res)))
        API.orderUploadFile(imgFormData).then(res => {
        // styleFormObj存放的key
          if (form.imageList) {
            form.imageList = form.imageList.concat(res.data.split(','))
          } else {
            arr = [...arr, ...res.data.split(',')]
          }
          this.uploadImageList = []
        }).finally(() => {
          this.imageLoading = false
        })
      })
    },
    // 图片压缩
    imageCompressorHandle(file) {
      let width = file.width
      let height = file.height
      if (file.width > 800) {
        width = 800
        height = file.width / file.height * 800
      }
      return new Promise((resolve, reject) => {
        new ImageCompressor({
          file,
          quality: 0.4, // 压缩质量
          width: width,
          height: height,
          mimeType: file.type === 'image/webp' ? 'image/jpeg' : 'auto',
          success(result) {
            resolve(result)
          }
        })
      })
    },
    imgVisit(imgUrl) {
      this.dialogImageUrl = imgUrl
      this.dialogVisible = true
    },
    imgUrlDelete(arr, index) {
      arr.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1187px;
  min-width: 1187px;
  margin: 0 auto;

  .fontfine {
    /deep/span {
      font-weight: normal;
    }
  }

  .rufund {
    font-size: 18px;
    font-weight: 500;
    margin: 8px 0;
  }

  .record {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .text {
      color: #eb5757;
      font-size: 18px;
      font-weight: 500;
    }
    .record-button {
      width: 150px;
      height: 44px;
      border-radius: 22px;
    }
  }

  .details {
    display: flex;
    justify-content: space-between;
    .left {
      width: 812px;
      .reason {
        width: 100%;
        margin-bottom: 5px;
        padding: 12px 14px;
        background-color: #fff;
        .el-form-item {
          .el-select {
            width: 300px;
            /deep/.el-input__inner {
              border-radius: 2px;
            }
            /deep/ .el-input__suffix {
              height: 36px;
            }
          }
        }
        /deep/.el-textarea__inner {
          border: 0;
        }
      }
      .content {
        .not-data {
          display: flex;
          height: 100%;
          padding: 68px 0;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          background-color: #fff;
          .tips-text {
            color: #747a87;
            font-size: 16px;
            margin-top: 28px;
          }
        }
      }
    }
    .right {
      width: 355px;
      .amount-info {
        padding: 22px;
        background-color: #fff;
        border-bottom: 1px solid #f5f7f7;
        .title {
          font-size: 18px;
          font-weight: 500;
        }
        p {
          display: flex;
          color: #747a87;
          font-size: 14px;
          font-weight: 500;
          margin-top: 20px;
          justify-content: space-between;
          .money {
            color: #10141d;
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
      .refund-info {
        background-color: #fff;
        p {
          display: flex;
          padding: 22px;
          justify-content: space-between;
          .total {
            font-size: 18px;
            font-weight: 500;
          }
          .money {
            color: #10141d;
            font-size: 24px;
            font-weight: 500;
          }
        }
        .button {
          padding: 12px;
          margin-top: 3px;
          .el-button {
            width: 100%;
          }
        }
      }
    }
  }
}
/deep/.el-upload--picture-card {
  width: 70px;
  height: 72px;
  position: relative;
  margin-right: 10px;
}
/deep/.el-icon-plus {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.imageListBox {
  padding: .1rem;
  .uploadBox {
    width: 70px;
    height: 72px;
  }
  .pictureCard {
    margin: 0 10px 10px 0;
    position: relative;
    width: 70px;
    height: 72px;
    border-radius: 6px;
    border: 1px solid #CDD4DD;
    cursor: pointer;
    >img {
        height: 100%;
        width: 100%;
        border-radius: 6px;
    }
    .deleteIcon {
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 30px;
        border-radius: 2px 6px 2px 30px;
        background: rgba(71, 71, 71, 0.6);
        transition: background .5s 0s;
        cursor: pointer;
    }
    .deleteIcon:hover {
        background: rgba(19, 18, 18, 0.6);
    }
    .el-icon-close {
        position: absolute;
        top: 6px;
        right: 6px;
        color: #fff;
        cursor: pointer;
        z-index: 10;
    }
    .el-icon-close:hover ~ .deleteIcon {
        background: rgba(19, 18, 18, 0.6);
    }
  }
}
</style>
